import { type FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { toShortNumFormat } from '@common/lib/toShortNumFormat';
import { type ProductionRecipeItemProps } from '@common/types/components';
import { type PlantTypeText } from '@common/types/plant';
import { type ResourceTypeText } from '@common/types/resource';
import { ResourceItem } from '@components/ResourceItem/ResourceItem';
import { StringXSmall } from '@components/Typography/Typography';
import { selectResourceStorageByName } from '@redux/selectors/userSelectors';
import { useAppSelector } from '@redux/store';
import cn from 'classnames';

import { AppRoute } from '@/common/app/routes';

interface Props extends ProductionRecipeItemProps {
  withStock?: boolean;
}

const ProductionRecipeItem: FC<Props> = ({ name, quantity, withStock }) => {
  const storageStock = useAppSelector((state) =>
    selectResourceStorageByName(
      state,
      name as ResourceTypeText | PlantTypeText,
    ),
  );
  const navigate = useNavigate();

  const onClick = (): void => {
    navigate(AppRoute.FACTORY + `/${name}`);
  };

  const isEnough = (storageStock || 0) >= quantity;

  return (
    <div onClick={onClick} className="flex flex-col items-center">
      <ResourceItem
        overlay={isEnough ? undefined : 'red'}
        variant="light"
        radius="full"
        size={{ width: '2.5rem', height: '2.5rem' }}
        kind={name as ResourceTypeText | PlantTypeText}
        className="mb-[6px] backdrop-blur-3xl"
      />
      {withStock && (
        <StringXSmall
          weight="medium"
          className={cn('mb-1', isEnough ? '!text-white/40' : '!text-red')}
        >
          {toShortNumFormat(storageStock || 0)}
        </StringXSmall>
      )}
      <StringXSmall
        weight="bold"
        className={withStock ? '!text-red' : '!text-white/40'}
      >
        {`${withStock ? '-' : ''}${toShortNumFormat(quantity)}`}
      </StringXSmall>
    </div>
  );
};

export { ProductionRecipeItem };
